import axios from "axios"

const getAdminBaseUrl = (tenant = 'dimitra') => {
    const baseUrl = tenant === 'kenya' ? process.env.VUE_APP_KENYA_BASE_URL : process.env.VUE_APP_BASE_URL
    return (baseUrl || '').replace(/\/+$/, '')
}

const getPublicBaseUrl = (tenant = 'dimitra') => {
    const adminBaseUrl = getAdminBaseUrl(tenant)
    return adminBaseUrl.replace(/\/admin$/, '')
}

const buildUrl = (baseUrl, path) => {
    const normalizedPath = path.startsWith('/') ? path : `/${path}`
    return `${baseUrl}${normalizedPath}`
}

export default {
    // Get tutorials from public endpoint
    getTutorials(params = {}, tenant = 'dimitra') {
        const defaultParams = { page: 1, limit: 200, ...params }
        return axios.get(buildUrl(getPublicBaseUrl(tenant), '/public/tutorials'), { params: defaultParams })
        .then(({data}) => data)
        .catch(({response}) => Promise.reject(response))
    },

    // Get all tutorials for admin management
    getAllTutorials(params = {}, tenant = 'dimitra') {
        return axios.get(buildUrl(getPublicBaseUrl(tenant), '/public/tutorials/admin/all'), { params })
        .then(({data}) => data)
        .catch(({response}) => Promise.reject(response))
    },

    // Get all tutorials for admin management (non-public endpoint)
    getAllInternalTutorials(params = {}) {
        const defaultParams = { page: 1, limit: 200, ...params }
        return axios.get('../tutorials', { params: defaultParams })
        .then(({data}) => data)
        .catch(({response}) => Promise.reject(response))
    },

    // Create a new tutorial (admin)
    createTutorial(tutorialData, tenant = 'dimitra') {
        return axios.post(buildUrl(getPublicBaseUrl(tenant), '/public/tutorials'), tutorialData)
        .then(({data}) => data)
        .catch(({response}) => Promise.reject(response))
    },

    // Update a tutorial (admin)
    updateTutorial(id, tutorialData, tenant = 'dimitra') {
        return axios.put(buildUrl(getPublicBaseUrl(tenant), `/public/tutorials/${id}`), tutorialData)
        .then(({data}) => data)
        .catch(({response}) => Promise.reject(response))
    },

    // Delete a tutorial (admin)
    deleteTutorial(id, tenant = 'dimitra') {
        return axios.delete(buildUrl(getPublicBaseUrl(tenant), `/public/tutorials/${id}`))
        .then(({data}) => data)
        .catch(({response}) => Promise.reject(response))
    },

    // Read global tutorial exclusion status for an organization (admin)
    getGlobalExclusionStatus(organization_id, tenant = 'dimitra') {
        return axios.get(buildUrl(getPublicBaseUrl(tenant), '/public/tutorials/admin/global-exclusion/status'), { params: { organization_id } })
        .then(({data}) => data)
        .catch(({response}) => Promise.reject(response))
    },

    // Update global tutorial exclusion flag for an organization (admin)
    setGlobalExclusion(organization_id, excludeGlobalTutorials, tenant = 'dimitra') {
        return axios.put(buildUrl(getPublicBaseUrl(tenant), '/public/tutorials/admin/global-exclusion'), { organization_id, excludeGlobalTutorials })
        .then(({data}) => data)
        .catch(({response}) => Promise.reject(response))
    },
    getOrganizations(tenant = 'dimitra') {
        const url = tenant === 'kenya'
            ? buildUrl(getPublicBaseUrl(tenant), '/public/organization')
            : buildUrl(getAdminBaseUrl(tenant), '/organization/all')
        return axios.get(url)
        .then(({data}) => data)
        .catch(({response}) => Promise.reject(response))
    }
}

